// eslint-disable-next-line import/prefer-default-export
export const generateRandomId = () =>
  `-${Math.random()
    .toString(36)
    .substr(2, 5)}`
